import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M11.785 17H9.90503C9.49103 17 9.15503 17.336 9.15503 17.75C9.15503 18.164 9.49103 18.5 9.90503 18.5H11.785C12.199 18.5 12.535 18.164 12.535 17.75C12.535 17.336 12.199 17 11.785 17Z"
      fill="currentColor"
    />
    <path
      d="M20.2499 12.5C20.6639 12.5 20.9999 12.164 20.9999 11.75V5.398C20.9999 4.076 19.9449 3 18.6479 3H10.0989C8.87191 3 7.49991 4.025 7.49991 5.398V12C7.49991 12.474 7.67091 12.938 7.95491 13.335C7.77591 13.444 7.60791 13.578 7.45491 13.737L3.46191 18.001C3.00191 18.473 2.88191 19.16 3.14991 19.794C3.45491 20.516 4.15791 21 4.89791 21H14.3899C14.3949 21 14.3999 21 14.4049 21C15.5599 21 16.5689 20.126 17.4409 19.229L20.5379 15.523C20.9829 15.065 21.1169 14.476 20.8939 13.949C20.6469 13.363 20.0179 13 19.2499 13H10.0989C9.59591 13 8.99991 12.458 8.99991 12V5.398C8.99991 4.961 9.56491 4.5 10.0989 4.5H18.6479C19.1179 4.5 19.4999 4.903 19.4999 5.398V11.75C19.4999 12.164 19.8359 12.5 20.2499 12.5V12.5ZM9.14191 14.5H19.2499C19.3219 14.5 19.3809 14.508 19.4249 14.519L16.3289 18.224C15.9879 18.574 15.0849 19.5 14.3999 19.5C14.3979 19.5 14.3969 19.5 14.3949 19.5H4.89791C4.76591 19.5 4.59891 19.367 4.53191 19.211C4.48591 19.1 4.51691 19.067 4.54691 19.037L8.54291 14.769C8.64091 14.669 8.84691 14.5 9.14191 14.5V14.5Z"
      fill="currentColor"
    />
    <path
      d="M9.25 16.5H16.435C16.849 16.5 17.185 16.164 17.185 15.75C17.185 15.336 16.849 15 16.435 15H9.25C8.836 15 8.5 15.336 8.5 15.75C8.5 16.164 8.836 16.5 9.25 16.5V16.5Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'Laptop');

export default Icon;
